




















































































































import BaseItemsPage from "../BaseItemsPage";
import { WhatsappDetailItem } from "@/store/whatsapp/statistic/types";
import { Component } from "vue-property-decorator";
import WhatsappDetailFilter from "@/components/Whatsapp/Statistic/WhatsappDetailFilter.vue";
import { Getter } from "vuex-class";
import { dateFilter } from "@/utils/date-util";
import { ScrollButton } from "wings-ui-components";
import { colorClassByStatus } from "@/utils/page-utils";
import { MsgTransports } from "@/store/types";

@Component({
  components: {WhatsappDetailFilter, ScrollButton},
  filters: {dateFilter},
  methods: {colorClassByStatus},
})
export default class WhatsappDetail extends BaseItemsPage<WhatsappDetailItem> {

  @Getter("whatsappStatisticDetail") responseItems!: WhatsappDetailItem[];
  @Getter("isLoadingDetailStat") isLoadingDetailStat!: boolean;

  is_show_filter_additional: boolean = false;
  currentSort: string = "create_date";
  transport = MsgTransports.WHATSAPP

  tableFields: string[] = this.tableFieldsDefault;

  get tableFieldsDefault(): string[] {
    return [
      'create_date', 'originator', 'recipient', 'partner',
      'service_provider', 'message', 'status', 'detail',
    ];
  }

  getData(): WhatsappDetailItem[] {
    return this.responseItems;
  }
}
